import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import DiscardConfirmationModal from './DiscardConfirmationModal';
import { useAlert } from "./AlertContext";

export default function UnsavedChangesPrompt({ isDirty, entityName }) {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const { showAlert } = useAlert();

  // 🧭 Block in-app navigation
  useEffect(() => {
    if (!isDirty) return;

    const unblock = history.block((tx) => {
      setNextLocation(tx);
      setShowModal(true);
      return false;
    });

    return () => unblock();
  }, [isDirty, history]);

  // 🧱 Warn on browser/tab close
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDirty]);

  // ✅ Confirm leaving the page
  const confirmNavigation = () => {
    setShowModal(false);
    showAlert(`${entityName} discarded successfully`, "success", entityName, "discard");
    if (nextLocation) {
      const destination = nextLocation.location || nextLocation;
      const unblock = history.block(() => null);
      history.push(destination);
      setTimeout(() => unblock(), 0);
    }
  };

  // ❌ Stay on page
  const cancelNavigation = () => {
    setShowModal(false);
    setNextLocation(null);
  };

  if (!showModal) return null;

  return (

    <DiscardConfirmationModal
      isOpen={showModal}
      onCancel={cancelNavigation}
      onConfirm={confirmNavigation}
      entityName={entityName}  // 🔁 Change dynamically (e.g., “Category”, “Stock”)
    />
  );
}


